export const en = {
  abbr: 'Abbreviation',
  account: 'Account',
  accumulated_quantity: 'Accum. quantity',
  action: 'Actions',
  activate: 'Activate',
  active: 'Active',
  actor: 'Actor',
  add_cost: 'Add cost',
  add_discount: 'add discount',
  add_extra: 'add extra',
  add_fields: 'The following fields were added: ',
  add_item_value: 'Add Values',
  add_price: 'Add price',
  add_product_partial:
    'The product will be added as inactive until the required data is \
    completely filled',
  add_product: 'Add product',
  add_quantity: 'Add quantity',
  add_user_group: 'Add users to groups',
  add_user_permissions: 'Add permissions to users',
  add: 'Add {value}',
  add2: 'Add to {value}',
  added: 'Added',
  additional_data: 'Additional Data',
  additional_side: 'Additional side',
  address: 'Address',
  address2: 'Address 2',
  advertisement: 'Advertisement',
  addressee: 'To:',
  alert: 'Alert',
  all: 'All',
  allow_whatsapp_messages: 'Allow WhatsApp messages',
  amount: 'Amount|Qty',
  and: 'and',
  apparel: 'Apparel | Apparels',
  apparel_brand: 'Apparel Brand | Apparel Brands',
  apparel_brands: 'Apparel Brands',
  apparel_color: 'Apparel Color | Apparel Colors',
  apparel_configuration: 'Apparel Configuration',
  apparel_gender: 'Apparel Gender | Apparel Genders',
  apparel_genders: 'Apparel Genders',
  apparel_name: 'Apparel | Apparels',
  apparel_names: 'Apparel Names',
  apparel_product_label: 'Apparel',
  add_catalog_entry: 'Add',
  apparel_style: 'Apparel Style | Apparel Styles',
  apparel_styles: 'Apparel Styles',
  // ------------------------------------------------------------
  // APPAREL TRANSLATIONS
  // ------------------------------------------------------------
  apparel_names_translations: {
    'T-Shirts': 'T-Shirts',
    Caps: 'Caps',
    Aprons: 'Aprons',
    Backpacks: 'Backpacks'
  },
  apparel_company_required:
    'No ERP company is loaded for this session. Link the user to a company and sign in again.',
  apparel_genders_translations: {
    Unisex: 'Unisex',
    Men: 'Men',
    Women: 'Women',
    Youth: 'Youth',
    Kids: 'Kids',
    Toddlers: 'Toddlers'
  },
  apparel_styles_translations: {
    'Crew Neck': 'Crew Neck',
    'V-Neck': 'V-Neck',
    'Short Sleeve': 'Short Sleeve',
    'Long Sleeve': 'Long Sleeve',
    Sleeveless: 'Sleeveless',
    'With Pocket': 'With Pocket',
    'Without Pocket': 'Without Pocket',
    'Without Hood': 'Without Hood',
    'Without Zipper': 'Without Zipper',
    'Hoodie with Kangaroo Pocket': 'Hoodie with Kangaroo Pocket',
    'Full-Zip Hoodie with Kangaroo': 'Full-Zip Hoodie with Kangaroo',
    'Tag Free': 'Tag Free',
    'Tear Away Tag': 'Tear Away Tag',
    '5-Panel': '5-Panel',
    '6-Panel': '6-Panel',
    '7-Panel': '7-Panel',
    'Pre-Curved': 'Pre-Curved',
    'Flat Bill': 'Flat Bill',
    'Sandwich Bill': 'Sandwich Bill',
    Flexfit: 'Flexfit',
    'With Cuff': 'With Cuff',
    'Without Cuff': 'Without Cuff',
    Patterned: 'Patterned',
    'Bib Apron': 'Bib Apron',
    'Bistro Apron': 'Bistro Apron',
    'Waist Apron': 'Waist Apron',
    'Cobbler Apron': 'Cobbler Apron',
    'Cross-Back Apron': 'Cross-Back Apron',
    'Tuxedo Apron': 'Tuxedo Apron',
    'Dishwasher Apron': 'Dishwasher Apron',
    'Server Apron': 'Server Apron',
    Backpack: 'Backpack',
    Daypack: 'Daypack',
    'Tote Backpack': 'Tote Backpack',
    'Roll-Top Backpack': 'Roll-Top Backpack',
    'Sling Bag': 'Sling Bag',
    'Tactical Backpack': 'Tactical Backpack',
    'Hiking Backpack': 'Hiking Backpack',
    'Drawstring Bag': 'Drawstring Bag'
  },
  fabric_types_translations: {
    '100% Cotton': '100% Cotton',
    '100% Polyester': '100% Polyester',
    Blends: 'Blends',
    'Cotton Poly': 'Cotton Poly',
    '50/50 Blend': '50/50 Blend',
    Twill: 'Twill',
    '100% Acrylic': '100% Acrylic',
    Cotton: 'Cotton',
    'Poly-Cotton Blend': 'Poly-Cotton Blend',
    Denim: 'Denim',
    Canvas: 'Canvas',
    Nylon: 'Nylon',
    Polyester: 'Polyester',
    'Denier Polyester': 'Denier Polyester',
    'Ripstop Poly': 'Ripstop Poly'
  },
  apparel_colors_translations: {
    Black: 'Black',
    White: 'White',
    'Navy blue': 'Navy blue',
    Red: 'Red',
    Orange: 'Orange',
    Gray: 'Gray'
  },
  approvalStatus: 'Approval status',
  approve: 'Approve',
  approved: 'Approved',
  aproved_purchase_order: 'Purchase order approved',
  aproved_quote: 'Approve quote',
  area: 'Area | Areas',
  are_sure: 'Are you sure?',
  are_you_sure: 'Are you sure {action} {model}?',
  as_producer: 'As producer',
  assign_people: 'Assign {value}',
  assign: 'Assign',
  assignament_date: 'Assignment date',
  assignaments: {
    department: 'Departments assigned on project',
    designers: 'Designers assigned on project',
    drivers: 'Drivers assigned to the project',
    productions: 'Producers assigned to the project',
    suborderToDrivers: 'Sub-orders assigned to the driver'
  },
  assignDesigner: 'Assign Designer',
  assignDesigners: 'You must assign designers to the project',
  assignDriver: 'Assign Driver',
  assigned: '{value} assigned',
  assignedDesign: 'Assigned to designer',
  assignedDesigns: 'Assign designs',
  assignedOneDesigner: 'You can only assign one designer',
  assignedOneDriver: 'You can only assign one driver',
  assignedProducts: 'Assigned products',
  assignProduction_no:
    'Upon approval of the design, you will be able to assign production team \
    members to this sub-order',
  assignProducer: 'Assign production department or equipment',
  assignProduction: 'Production departments',
  assignProductions: 'You must assign a production department to the project',
  assignSubOrder: 'Assign sub-orders',
  assigned_to_me: 'Assigned to me',
  at_home: 'At home',
  attach_file: 'Attach file',
  attach_images: 'Click here to add images manually',
  attachments: 'Attachments',
  attention_queues: 'Attention queues',
  attention_queues_hint:
    'Who attends and where unclassified conversations land.',
  attributes: 'Attributes',
  audit_system: 'Shredded by the system',
  audit: 'Audit',
  available: 'Available',
  avalaibleDesigners: 'Designers available for project',
  back: 'Back',
  background_color: 'Background Color',
  background_image: 'Background image',
  background_url: 'URL',
  background: 'Background',
  backup_schemas: 'Back up database',
  balance: 'Balance',
  banners: 'Banners',
  base_salary: 'Base salary',
  base: 'Base',
  basic: 'Basic information',
  before: 'Before',
  billable_conversations: 'Billable conversations',
  billable_messages: 'Billable messages',
  billing_address: 'Billing Address',
  billing_and_payment: 'Billing and payment',
  billToPay: 'Bills to pay',
  blocked: 'Blocked',
  body: 'Body',
  bool: 'Without price',
  boolean: 'Boolean',
  both: 'Both',
  bought_date_and_rent_date: 'Bought or Rent Date',
  bought_date: 'Bought Date',
  brand: 'Brand',
  brandModels: 'Models of {brand}',
  business_hours: 'Business hours',
  business_hours_hint:
    'Evaluated in the company timezone. A day with no hours is closed.',
  bussiness_info: 'Business Info',
  buy: 'Buy',
  by_ranges: 'By Ranges',
  bypercent: 'By percent',
  calendar: 'Calendar',
  can_be: 'Can be',
  cancel_quotation_validation: 'Reason must contain at least one character',
  cancel_quotation: 'Indicate the reason for canceling the quotation',
  cancel_specific: '{value} cancel',
  cancel: 'Cancel',
  canceled: 'Canceled',
  cancelorder: 'Do you want to cancel the order {order}?',
  cant_active:
    'You must fill in the information for all steps of the form first in order \
    to modify this option.',
  carrouselTips: 'Tips carousel',
  cash: 'Cash',
  category: 'Category | Categories',
  cc: 'Credit Card',
  cellphone: 'Cellphone',
  change_status: {
    mail_delivery_notification: 'Mail delivery verification',
    shipment_preview: 'Shipment preview',
    ask: 'Do you want to send the notification by mail directly to the customer?',
    notification: 'Change of status of a sub-order',
    to: 'Would you like to change the status of the sub-order to {value}?'
  },
  change_to: 'Change to',
  change: 'Changed | Changed | Change',
  changeprice: 'Change price|Change prices',
  chat_not_started: 'The message could not be sent',
  chat: 'Chat',
  check: 'Check',
  city: 'City',
  clean_image: 'Clean image',
  clear: 'Clear',
  click_repository: 'Click the square to send to repository',
  click_to_enlarge: 'Click to enlarge',
  clone: 'Clone',
  cloned: 'cloned',
  close: 'Close',
  code: 'Code',
  color_nav: 'Color of navbar',
  color_toolbar: 'Color of toolbar',
  color: 'Color|Colors',
  cols_empty: 'You must add at least one column in {col}',
  cols_must_be_unique: 'Cols title must be unique',
  cols_tab_be_unique: 'Cols tabs must be unique',
  column_compare:
    'The quantity column of the detail matrix must be the same as that of the \
    product matrix',
  column: 'Column',
  commercial_messages: 'Commercial messages',
  commission_assigned: 'Commission Assigned',
  commission: 'Commission|Commissions',
  commissionPermission:
    'The condition is the number of sales to be made, \
    the value will always be greater than or equal to {val}',
  communication_preferences: 'Communication preferences',
  communication_preferences_hint:
    'They decide which updates the customer receives on WhatsApp.',
  companies: 'Companies',
  company_address: 'Company Address',
  company_info: 'Company information',
  company_management: 'Companies Management',
  company_name: 'Company Name',
  company_settings: 'Company settings',
  tenant_guide: 'Welcome guide',
  tenant_guide_empty: 'The company has not completed the welcome guide yet.',
  tenant_guide_completed: 'Guide completed',
  tenant_guide_primary_service: 'Primary service',
  company: 'Company',
  concurrence: 'Customer concurrence',
  condition: 'Condition',
  confirm_change_designer: 'Do you want to change the designer assigned?',
  confirm_delete:
    'Do you want to delete this record? This action cannot be undone',
  confirm: 'Confirm',
  connect_whatsapp: 'Connect WhatsApp',
  connected: 'Connected | Connected',
  contact: 'Contact | Contacts',
  conversation_not_opened: 'The conversation could not be opened',
  conversation: 'Conversation | Conversations',
  copy_prices: 'Copy prices',
  copy_ranges: 'Copy ranges | Copied ranges | Edited ranges',
  copy: 'Copy',
  copyright: 'All rights reserved.',
  correction: 'Correction',
  corrective: 'Corrective',
  preventive: 'Preventive',
  cost_by_dimensions: 'Cost calculated by dimensions',
  cost_lat_prom: 'Promotion Cost (Latin America)',
  cost_lat: 'Cost (Latin America)',
  cost_prom: 'Promotion Cost',
  cost_suggest: 'Total cost',
  cost: 'Cost | Costs',
  costalert: 'The product cost must be greater than 0',
  country: 'Country',
  create_btn: 'Create',
  create_customer: 'Create customer',
  create_email: 'Create email',
  create_matrix_template: 'Create matrix template',
  create_quotation: 'Create quotation',
  create_value: 'Create Value',
  create: 'Create {model}',
  created: 'Created | Created',
  created_at: 'Created At',
  creation_date: 'Creation date',
  creation_user: 'Creation user',
  credentials: 'Credentials',
  credit_limit: 'Credit Limit',
  cumulative: 'Cumulative',
  currency_info: 'Currency Info',
  currency: 'Currency|Currencies',
  current_status: 'Current status',
  customer_manager: 'Customer Management',
  customer_origin_date: 'Customer origin date',
  customer_origin: 'Customer Origin',
  customer_without_conversation:
    'This customer has not written on WhatsApp yet',
  customer: 'Customer|Customers',
  customerAddress: 'Customer Address',
  customerCompany: 'Customer Name or Company',
  customersReport: 'Customer report',
  confirm_sale_stock:
    'Not enough inventory. Do you wish to continue with the sale?',
  daily: 'Daily',
  dark_mode: 'Dark Mode',
  dark: 'Dark color',
  dashboard_default: 'Choose default screen',
  dashboard: 'Dashboard',
  date_from: 'From',
  date_pay: 'Payment Date',
  date_to: 'To',
  date: 'Date',
  dateDelivery: 'Date of delivery',
  dateDesign: 'Design date',
  dateDone: 'Order Completion Date',
  dateOrder: 'Order Date',
  dateProduction: 'Production Date',
  dates: 'Dates',
  day_terms: 'Days to pay credit',
  days_list: {
    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday'
  },
  days: 'Days',
  decimal: 'Decimal',
  default_field: 'Set a default pricing formula',
  default: 'Default',
  default_queue: 'Default queue',
  deincorporation: 'Deincorporation',
  delete_matrix: 'Delete Matrix',
  delete_no:
    'This state cannot be deleted because it contains some sub-orders. First \
    change the sub-orders to a current state',
  delete_record_question: 'You want to delete this record?',
  delete: 'Remove|Removed',
  deleted: 'It was deleted',
  delivery_at_home: 'Delivery - At home',
  delivery_date: 'Delivery Date',
  delivery_notifications: 'Delivery notifications',
  delivery_pickup: 'Delivery - Pickup',
  delivery_status: 'On delivery | Rejected | Delivered',
  delivery: 'Delivery',
  deliverytime: 'Delivery time',
  department: 'Production Department',
  deploy: 'Deploy',
  description_lat: 'Description (Latin America)',
  description: 'Description',
  descriptions: 'Descriptions',
  deselect_image: 'Deselect image',
  design_completed: 'Designs Completed',
  design_finished: 'Design - Finished',
  design_in_process: 'Design - On design',
  design_in_wait: 'Design - In wait',
  design_notifications: 'Design notifications',
  design_rejected: 'Design - Rejected',
  design_status: 'Design status',
  design_under_review_approved: 'Design under review - Approved',
  design_under_review_in_design: 'Design under review - In design',
  design_under_review_in_wait: 'Design under review - In wait',
  design_under_review_rejected: 'Design under review - Rejected',
  design_under_review: 'Design under review',
  design: 'Design | Designs',
  designer: 'Designer',
  designerOnDuty: 'Designer on duty',
  designerReport: 'Activity report for designers',
  designers: 'Designers',
  assigned_designer_subject: 'Suborder assignment: {suborder}',
  assigned_designer_body: `Hello {designerName},

We are sharing with you that you have been assigned a new design order.

Please review it when possible and follow up. If you need more information, files, or have any questions about what is required, let us know.

Thank you.

Best regards,
{companyName}`,
  detail: 'Detail',
  details_production: 'Production Details',
  dimension: 'Dimensions',
  dinamic_cost: 'Dynamic cost',
  discard: 'Discard',
  disconnected: 'Disconnected',
  discount: 'Discount',
  discrepancy: 'Discrepancy | Discrepancies',
  everyone: 'Everyone',
  friday: 'Friday',
  inbox: 'Inbox',
  integration_disabled_globally:
    'The WhatsApp integration is disabled for the whole platform.',
  integration_enabled_globally:
    'The WhatsApp integration is enabled for the whole platform.',
  last_30_days: 'Last 30 days',
  last_7_days: 'Last 7 days',
  last_90_days: 'Last 90 days',
  loaded: 'Loaded',
  marketing: 'Promotions and commercial messages',
  matching_customers: 'Matching customers',
  message_preview: 'This is how the customer will see it',
  message_to_customer: 'Message for the customer',
  missing: 'Missing',
  monday: 'Monday',
  no_approved_templates:
    'This business has no templates approved by the platform yet.',
  no_conversations: 'No conversations',
  no_messages: 'No messages',
  no_queues: 'No queues configured',
  no_quotations: 'This customer has no quotations',
  no_usage: 'No usage in the period',
  notification_whatsapp_account_disabled:
    'WhatsApp disabled the connection for {phone}. Messages cannot be sent or received until this is resolved with the platform.',
  notification_whatsapp_message: '{name}: {preview}',
  notification_whatsapp_token_expired:
    'The WhatsApp connection for {phone} expired on {date}. Reconnect it to be able to send.',
  notification_whatsapp_token_expiring:
    'The WhatsApp connection for {phone} expires on {date}. Reconnect it before that date.',
  number_managed_by_provider: 'Managed by the provider',
  onboarding_cancelled: 'The window was closed before finishing',
  onboarding_failed: 'The WhatsApp account could not be connected',
  onboarding_hint:
    'You can connect a number the business already uses in the WhatsApp Business app, as long as it is version 2.24.17 or later. Connecting it unlinks that number’s linked devices, such as WhatsApp Web.',
  onboarding_incomplete:
    'The window did not return the account or the number. Try again and pick a number at the end of the wizard.',
  onboarding_intro:
    'Connect the print shop WhatsApp number. A platform window opens where you pick the account and the number; once finished it is ready to send and receive.',
  onboarding_not_available:
    'The platform application details are not set yet. That is system administrator configuration.',
  open_whatsapp_chat: 'Open the WhatsApp conversation',
  operational_messages: 'Operational messages',
  order_updates: 'Order updates',
  out_of_hours_message: 'Out of hours reply',
  out_of_hours_message_hint: 'Sent once every twelve hours per conversation.',
  out_of_hours_queue: 'Out of hours queue',
  payment_reminders: 'Payment reminders',
  period: 'Period',
  physicalDiscrepancy: 'Physical inventory discrepancy report',
  physicalInventory: 'Physical Inventory | Physical Inventories',
  discrepancynote: 'Discrepancy Note',
  dispatchAddress: 'Dispatch address',
  distance: 'Distance',
  done: 'Done',
  dont_templates_email:
    'This state does not have an email template, please edit email manually',
  email_template_required:
    'You must configure an email template for the sub-order status first.',
  email_smtp_required:
    'You must configure an SMTP email server before creating a template.',
  download: 'Download',
  draft: 'Draft',
  drag_and_drop_the_image_to_this_box: 'Drag and drop the image to this box',
  drag_drop_image: 'Drag and drop an image',
  driver: 'Driver | Drivers',
  edit_btn: 'Create',
  edit_product_partial:
    'The product will be inactive until the required data is completely filled',
  edit_product: 'Edit product',
  edit: 'Edit',
  editable_active:
    'To activate this button, you need administrator credentials',
  editable: 'Editable',
  edited: 'Edited | Edited',
  editing: '{value} edit',
  email_edit:
    'If you want to confirm or edit the email information, press the edit \
    button',
  email_sent: 'Email sent',
  email_setting: {
    default_iprint_email_service: 'Default Iprint email service',
    default_setting: 'Default setting',
    email_SMTP_setting: 'Email SMTP settings',
    gmail: {
      google: 'Google',
      gmail: 'Gmail',
      setting_gmail: 'Settings Gmail',
      msg1: 'Prerequisite: be logged into the browser with your Google account',
      msg2: 'Enter the following link:',
      msg3: 'To generate the password, register the application: ',
      msg4: 'Please enter your account credentials (Email and password)'
    },
    host: 'Host',
    host_port: 'Host port',
    smtp_type: 'SMTP type',
    main: 'Main',
    outlook: {
      outlook: 'Outlook',
      setting_outlook: 'Settings Outlook',
      msg1: 'Prerequisite: be logged into the browser with your Outlook \
        account',
      msg2: 'Enter the following link:',
      msg3: 'Allow devices and applications to use POP settings: Yes',
      msg4: 'Please enter your account credentials (Email and password)'
    },
    use_tls: 'Use TLS',
    other: {
      setting_other: 'Setting other',
      msg1: 'Prerequisite: Have access to the SMTP configuration of the mail \
        service of your choice',
      msg2: 'Fill all the information requested in the form in this section'
    }
  },
  email_subdomain: 'Subdomain approval of {value}',
  email: 'Email | Emails',
  emails_list: 'Emails List',
  empty_data: 'No data found',
  empty_message: 'You must specify message content',
  empty_states: 'No states found',
  end_date: 'End date',
  equipment_maintenance: 'Equipment Maintenance',
  equipment: 'Equipment',
  equipmentReport: 'Equipment report',
  equipments_manage: 'Equipment Management',
  equipments: 'Equipments',
  error_send_email: 'Error send email',
  example: 'Example',
  expected_date: 'Expected date',
  expense_type: 'Expense type',
  expense_validation:
    'The start date can not be greater than or equal to the final date | There \
    are no months in that range of dates | There are no weeks in that range of \
    dates',
  expense: 'Expense|Expenses',
  expenseAccount: 'Expense Account',
  expenseCategory: 'Expense Category',
  expenses_recurring: 'Recurring expenses',
  expenses_regular: 'Payment Report',
  expensesReport: 'Expenses report',
  expiration_days: 'Expiration Days',
  expired: 'Session expired',
  extra_cost: 'Extra Cost',
  extra_discount: 'Extras/Discounts',
  extra: 'Extra',
  f2key: 'Press the F2 key to view the product cost',
  fabric_type: 'Fabric Type | Fabric Types',
  fabric_types: 'Fabric Types',
  favorite: 'Favorite',
  fax: 'Fax',
  fields_changed: 'The following fields were modified: ',
  file_recomended:
    'Size: 300px High x 300px Width, Resolution: 120Dpi, File types: PNG-24 \
    High Resolution',
  file_type: 'File type',
  file: 'File',
  fill_company_address: 'Complete the company address fields first',
  fill_fields: 'Fill out all required fields first',
  filter_role: 'Filter by role',
  filter: 'Filters',
  finalize: 'Finalize',
  finished: 'Finished',
  finishedAndRemove:
    'At the end of the order, your images will be deleted from the system',
  first_name: 'First name',
  forgot: 'Forgot your password?',
  form: 'Form',
  format_date: 'Format date',
  format: 'Format|Formats',
  formula_model: 'Model Formula',
  formula_simple: 'Formula',
  formula: 'Pricing Formula',
  formulaDivisionZero: 'Invalid division by zero',
  formulaNoValid: 'Invalid formula',
  formulattributes: 'Pricing attributes',
  fraction: 'Fraction',
  from: 'From',
  fullname: 'Fullname',
  general: 'General|General Product List',
  given_to: 'Given to',
  globaltax: 'Tax|Taxes',
  go_home: 'Go Home',
  group_title: 'Group title',
  has_credit: 'Credit',
  hasCondition: 'Has condition',
  height: 'Height',
  hidden: 'Hidden',
  hide: 'Hide',
  historical: 'Historical',
  history_customer: 'Customer history',
  history_product: 'History Products',
  history_supplier: 'Supplier history',
  history: '{model} history',
  hours: 'Hours',
  identification: 'Identification',
  image_design_and_approval: 'Image design and approval',
  image_error_message:
    "We're sorry, but something went wrong in the process. Please try again or \
    contact us",
  image: 'Image',
  in_design: 'On design',
  in_process: 'On process',
  in_production: 'On production',
  in_wait: 'On wait',
  inactive: 'Inactive',
  incorporation: 'Incorporation',
  increase: 'Increase price',
  increaseStock: 'Increase Stock',
  invalid_type_and_file_please_select_one_allowed:
    'Invalid type and file, please select one allowed.',
  inventoriable: 'Inventoriable',
  inventoriable_push: 'Inventoriable Push Notification',
  inventory: 'Inventory',
  invoice: 'Invoice',
  invoices: 'Invoices',
  invoiceSetting: 'Invoicing configuration',
  invoicesReport: 'Invoices report',
  ip_addr: 'IP address',
  is_multipliable: 'Multipliable by the quantity',
  is_required: '{name} is required',
  item: 'Item',
  keep_off: 'Keep off',
  label: 'Label | Labels',
  last_name: 'Last name',
  leave: 'Leave|forgotten',
  length: 'Length',
  less_price: 'Price is less than cost',
  level: 'Customer type | Customer types',
  levelRequired: 'Customer type is required for prices',
  lineal_meter: 'Lineal meter',
  list_schemas: 'List of stored schemas',
  list: 'List',
  loading_image: 'Loading...',
  login_failed: 'Login failed',
  license_account_suspended:
    'iPrintPOS access is suspended because of your company’s license status. Contact your administrator.',
  login: 'Sign in',
  loginlogs: 'Login logs',
  logout: 'Logout',
  main_email: 'Main Email',
  main_matrix: 'Main Matrix',
  main_status: 'Main Status',
  maintenance_recurrence: 'Equipment maintenance recurrence',
  maintenance: 'Maintenance',
  matrix_loaded:
    'Matrices that do not correspond to the product matrix will not be loaded',
  matrix_prices: 'Matrix Prices',
  matrix_table: {
    add_cols: 'Add Column',
    add_rows: 'Add Row',
    remove_cols: 'Remove Column',
    remove_rows: 'Remove Row',
    initial_range: 'Initial Range',
    final_range: 'Final Range',
    tab_title: 'Tab title'
  },
  matrix_template: 'Matrix template',
  matrix: 'Matrix',
  max_height: 'Max height',
  max_size: 'Max size',
  max_width: 'Max width',
  measure: 'Unit measurement | Unit measure',
  measureRequired:
    'Selling formula is required, products without this value will be inactive \
    until they are assigned.',
  member: 'Members | Member',
  message: 'Message',
  minReorder: 'Reorder Minimum | Minimum Inventory Report',
  pricing_change_notice:
    'From {date} the platform also charges replies within 24 hours and utility templates.',
  production_notifications: 'Production notifications',
  queue_users_hint: 'With no users, the notice goes to the whole company.',
  quotation_message_hint: 'It is sent along with the quotation PDF.',
  quotation_not_sent: 'The quotation could not be sent',
  quotation_sent: 'Quotation sent',
  received_messages: 'Received',
  reconnect_whatsapp: 'Reconnect',
  region: 'Country code',
  region_hint: 'Two letters. Used to read phone numbers.',
  related: 'Related',
  saturday: 'Saturday',
  sdk_not_loaded: 'The platform window could not be loaded',
  see_orders: 'See orders',
  select_conversation: 'Select a conversation',
  select_quotation: 'Select a quotation',
  send_quotation: 'Send quotation',
  sent_messages: 'Sent',
  stock_min_reached: 'Minimum reached in product: {product}',
  minStock: 'Min Stock',
  minutes: 'Minutes',
  mode: 'Mode',
  model_product: 'Model Product',
  model: 'Model',
  models: 'Models',
  month_list: {
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December'
  },
  month: 'Month',
  monthly: 'Monthly',
  more_info: 'More Information',
  movement_type: 'Movement type',
  movement: 'Movement | Movements',
  movementsReport: 'Movements report',
  msg_color: 'Message color',
  msg: 'Message',
  multi_choice: 'Multi-Choice',
  must_be_numeric: 'must be numeric',
  my_profile: 'My profile',
  name: 'Name',
  new_chat: 'New Chat',
  new_order_status: 'New order status',
  new_package: 'New Package',
  new_password: 'New password',
  new: 'New',
  newMessage: 'New message in the order',
  next_date: 'Next date',
  next_number: 'Next number',
  next_sub_state: 'New substate',
  next: 'Next',
  nextStatus: 'Next status {state}',
  no_addi_data: 'No additional data',
  no_changes: 'There are no changes',
  no_matrix: 'You must add a matrix to the template',
  no_notifications: 'No new notifications',
  no_producers: 'There are no registered producers',
  no_roles: 'No roles',
  no_suborders_outstanding: 'There are no suborders outstanding payment',
  notes_chat: 'Notes/Chat',
  notifications_events: 'Notifications and events',
  notifications: 'Notifications',
  notification_suborder_update: '{status} | {name}',
  number_control: 'Control number',
  number_increment: 'Number increment',
  number: 'Number',
  object_repr: 'Object representation',
  observation: 'Observation',
  of: 'of',
  old_password: 'Old password',
  on_bytes: 'On Bytes',
  on_pixels: 'On Pixels',
  one_column: 'One Column',
  open: 'Abrir',
  operator: 'Operator',
  operators: 'Operators',
  optional_field: 'Optional',
  optional: '{value} (optional)',
  order_code: 'Order code',
  order_name: 'Order name',
  order_quantity: 'Ordered quantity',
  order_status: 'Order status',
  order: 'Order | Orders',
  ordercanceled: 'Order {order} canceled',
  ordercreated: 'Order {order} created',
  orderdelayed: 'Delayed order',
  orderend: 'Order {order} finished',
  orderquote: 'Order {order} in Quotation process',
  orderstatus: 'Sub-order Status',
  status_change_subject:
    'Status change for product {product}, from {old} to {new}',
  orderupdate: 'Change of product status {product}, from {old} to {new}',
  other_settings: 'Other settings',
  other: 'Other',
  out_of_range: 'Out of range',
  outsource: 'Outsource',
  outstanding: 'outstanding',
  overview: 'Overview',
  package: 'Package',
  padding: 'Padding',
  page: 'Page',
  pagenotfound: 'Error 404: Page Not Found',
  paid: 'Paid|Paid',
  partial: 'Partial Delivery',
  partialReception: 'Partial reception',
  participant: 'Participants',
  password_recovery: 'Password recovery',
  password: 'Password | Password confirm',
  pay: 'Pay | Pay',
  payment_address: 'Payment Address',
  payment_amount: 'Payment Amount',
  payment_number: 'Payment Number',
  payment_ref: 'Referential payment',
  payment_type: 'Payment Type',
  payment: 'Payment | Payments',
  paymenttype: 'Payment Method',
  pdocument: 'Purchase document',
  pending_quantity: 'Pending quantity',
  percent: 'Percent',
  perimeter: 'Perimeter',
  permanent: 'Permanent',
  permissionnotfound: 'You do not have enough permissions to enter this page',
  permissions_select: 'Select permissions',
  permissions: 'Permissions',
  perpage: 'Per page',
  personal_info: 'Personal Information',
  phone_number: 'Phone Number',
  phone: 'Phone | Phones',
  photo: 'Photo',
  pick_a_image: 'Pick an image',
  pickup: 'Pickup',
  position: 'Position',
  image: 'Image',
  duration: 'Duration',
  postproduction: 'Post-Production',
  prefix: 'Prefix',
  prefix_en: 'Prefix (EN)',
  prefix_es: 'Prefix (ES)',
  preprocess_approved: 'Preprocess - Aprroved',
  preprocess_canceled: 'Preprocess - Canceled',
  preprocess_quote: 'Preprocess - Quote',
  preprocess_sended_quote: 'Preprocess - Sended Quote',
  preprocess: 'Pre-Process',
  preproduction: 'Pre-Production',
  prev: 'Prev',
  previous_date: 'Previous date',
  previous_suborder_status: 'Previous status',
  price_calculation: 'Price calculation',
  price: 'Price | Prices | Price type',
  pricenegative: 'The price cannot be negative',
  pricepurchase: 'Purchased Price',
  pricepurchaseplus: 'Purchased price + extra cost',
  pricesale: 'Sales Prices',
  pricespecial: 'Special price',
  pricesuggest: 'Suggested Price',
  priceZero:
    'Prices that are 0 will be ignored and the amount of the suggested price \
    will be assumed',
  primary_color: 'Primary color',
  print: '{value} print',
  printquality: 'Print Quality',
  prodcategory: 'Product Category',
  prodlist: 'Product List',
  prodstatus: 'Products status',
  product_catalog: 'Product catalog',
  product_code: 'Product Code',
  product_code_preview_unavailable: 'Could not load the code preview',
  product_frequency: 'Quantity Sold',
  product_manage: 'Product management',
  product_name: 'Product Name',
  product_price: 'Product Price',
  product_sold: 'Products Sold',
  product: 'Product | Products',
  production_detail: 'Production detail',
  production_finished: 'Production - Finished',
  production_in_design: 'Production - In design',
  production_in_process: 'Production - In process',
  production_in_wait: 'Production - In wait',
  production_process_start: 'Start production process',
  production_process: 'Production process',
  production_ready_to_deliver: 'Production - Ready to deliver',
  production_ready: 'Production ready',
  production_rejected: 'Production - Rejected',
  production_status: 'Production status',
  production: 'Production',
  productions: 'Producer | Producers',
  productive_process: 'Productive process',
  productReport: 'Product report',
  profile: 'Profile | profile',
  profit_percent: 'Profit percent',
  profit: 'Profit',
  project_name: 'Project Name',
  promise_date: 'Promise date',
  purchase_history: 'Purchase history',
  purchase_order_name: 'Purchase order name ',
  purchase_order: 'Purchase order',
  purchase_prices: 'Purchase prices',
  purchase: 'Purchase | Purchases',
  purchased_product: 'Purchased product',
  purchaseproduct: 'Purchase product',
  purchasesorderlist: 'Purchases order list',
  purchaseHistory: 'Purchases history',
  purchasesReceiver: 'Purchases Receiver',
  purchasesReport: 'Purchases report',
  push_notifications: 'Push Notifications',
  push: 'Push',
  quantity_0: 'The quantity must be greater than zero',
  quantity: 'Quantity',
  quick_sale: 'Quick sale',
  quote: 'Quote',
  ranges: 'Ranges',
  rating: 'Rating',
  ready_to_deliver: 'Ready to deliver',
  reason: 'Reason',
  receivable: 'Accounts Receivable',
  received_date: 'Reception date',
  received_greater: 'The amount received cannot be greater than the slope',
  received_purchase_order: 'Products reception',
  received_quantity: 'Received quantity',
  received: 'Received',
  recent_chats: 'Recent Chats',
  reception_date: 'Reception date',
  reception: 'Reception',
  recurrent: 'Recurrence | Recurrent',
  reference: 'Reference',
  referred: 'Referred',
  register_subdomain: 'Register Subdomain',
  register_user: 'Register User',
  register: 'Register',
  registered: "You don't have an account?",
  registered2: 'Registered',
  registerLevel: 'Only four types of customer can be registered',
  regular: 'Regular',
  rejected: 'Rejected',
  removed: 'Removed',
  rent_date: 'Rent date',
  rent_end_date: 'Rent end date',
  rent_start_date: 'Rent start date',
  rent: 'Rent',
  report_type: 'Report type',
  reports: 'Reports',
  repository: 'Repository',
  required_field: 'Required field',
  this_field_is_required: 'This field is required',
  required: 'Saving error, fields required in blank',
  resend: 'Resend',
  restart: 'Restart | Restored',
  reverse_transaction_reason: 'Reason for reversing the transaction',
  reverse_transaction: 'Reverse transaction',
  review: 'Review',
  role_permissions: 'Role permissions',
  roles_areas: 'Areas',
  roles: 'Role | Roles',
  rotate_left: 'Rotate left',
  rotate_right: 'Rotate right',
  rounded: 'Rounded | Rounded enable',
  rounded2: 'Rounded',
  row_compare:
    'The number of columns in the detail matrix must be the same as in the \
    product matrix',
  row_per_page: 'Rows per page',
  row_title: 'Row title',
  rows_empty: 'You must add at least one row in {row}',
  rows_must_be_unique: 'Rows title must be unique',
  rush: 'Rush',
  salary: 'Salary | Salaries',
  sale_order: 'Sale order',
  sale_price: 'Sale price',
  sale: 'Sale | Sales',
  sales_percent: 'Sales percent',
  sales_prices: 'Sales prices',
  salesman: 'Salesman | Salesman',
  salesorderlist: 'Sales order list',
  salesReport: 'Sales report',
  salessuborderlist: 'List by Sale Sub-orders',
  same_billing: 'Same as Billing',
  same_company_address: 'Same as Company Address',
  same_payments: 'Same as Payment',
  save_backup: 'Schema backup was saved successfully',
  save_send_backup: 'The schematic was downloaded successfully',
  save_template:
    'You must save the template name before creating a production detail',
  save: 'Save | Save',
  schema: 'Schema',
  search: 'Search',
  second_value: 'Second Value',
  secondary_color: 'Secondary color',
  section_only: 'Section',
  section_sub: 'Subsection',
  section: '{value} Section',
  see_matrix: 'See Matrix',
  see_more: 'See more...',
  see: 'See',
  select_prod: 'No products selected',
  select_schema: 'Select the scheme',
  select_suborder:
    'You must select at least one sales suborder to enable the form',
  select: 'Select',
  selectClone: 'Select categories',
  selectClone2: 'Select category(ies) to clone',
  selectDetail: 'Select a production detail',
  selection: '{value} selection',
  send_artwork: 'Send Artwork',
  send_email_list: 'Send email list',
  send_email_schema: 'An email was sent successfully indicating the route',
  send_notification:
    'You want to send a notification to the client | You can notify the \
    customer that your order has been changed, so that the customer can \
    have an idea of what their order is like. Yes',
  send_purchase_order: 'Send purchase order',
  send_quote: 'Send quote',
  send: 'Send | Sent | Sent',
  sended_document: 'Order sent',
  sended_quote: 'Quote sent',
  sendonly: 'Send',
  sequence: 'Sequence | Sequences',
  serial: 'Serial',
  service: 'Service',
  services: 'Services',
  settingImage: 'Image setting',
  settings_for_image_upload: 'Settings for image upload',
  settings: 'Settings',
  settingTemplate: {
    dark_icons: 'Dark mode links',
    setting: 'Setting',
    settings_template: 'Settings of email template',
    image: 'Image | Images',
    icons: 'Social media links',
    text: 'Text',
    test_text: 'Test text',
    align: {
      align: 'Align',
      center: 'Center',
      left: 'Left',
      right: 'Right',
      justify: 'Justify'
    },
    size: {
      size: 'Size',
      small: 'Small',
      medium: 'Medium',
      large: 'Large'
    },
    text_color: 'Text color',
    font_size: 'Font size',
    font_style: {
      both: 'Both',
      font_style: 'Font style',
      italic: 'Italic',
      bold: 'Bold',
      normal: 'Normal'
    },
    header: 'Header',
    background_color: 'Background color',
    body: 'Body',
    footer: 'Footer'
  },
  shipping_address: 'Ship to',
  shippingAddress: 'Ship to',
  shop_list: 'Shop List',
  show: 'show',
  side: 'Side',
  sku_code: 'SKU Code',
  sms: 'SMS',
  sunday: 'Sunday',
  thursday: 'Thursday',
  timezone: 'Timezone',
  token_expires_soon:
    'The WhatsApp connection expires on {date}. Reconnect before that date or the print shop will stop being able to send messages.',
  total_conversations: 'Total conversations',
  tuesday: 'Tuesday',
  unassigned: 'Unassigned',
  unregistered_contact: 'Unregistered contact',
  usage: 'Usage',
  usage_hint:
    'WhatsApp charges per delivered message, by category and country.',
  // Screen that offers the WhatsApp add-on to a company without it
  whatsapp_addon_title: 'WhatsApp for your print shop',
  whatsapp_addon_subtitle:
    'Talk to your customers on WhatsApp without leaving iprintPOS.',
  whatsapp_addon_cta: 'I want to enable it',
  whatsapp_addon_contact_title: 'Enable the add-on',
  whatsapp_addon_contact_hint:
    'Get in touch and we will enable it for your company. This screen sends no notice.',
  whatsapp_addon_mock_1: 'Hi, I need 500 business cards',
  whatsapp_addon_mock_2: 'Can you send me the quote?',
  whatsapp_addon_mock_3: 'Great, I approve it',
  whatsapp_addon_mock_in: 'Hi, I need 500 business cards by Monday',
  whatsapp_addon_mock_out: 'Sending you the quote right now',
  whatsapp_addon_mock_in_2: 'Thanks, I approve it',
  whatsapp_addon_inbox_title: 'One inbox for the whole team',
  whatsapp_addon_inbox_text:
    'Conversations are split into queues and assigned to the right person, with the history in plain sight.',
  whatsapp_addon_crm_title: 'The customer, identified',
  whatsapp_addon_crm_text:
    'Whoever writes is linked to their CRM record, or created right from the conversation.',
  whatsapp_addon_quote_title: 'Quote without switching screens',
  whatsapp_addon_quote_text:
    'Build the quote and send the PDF from the conversation, with no data copied by hand.',
  whatsapp_addon_approval_title: 'From the chat to the work order',
  whatsapp_addon_approval_text:
    'The customer replies in the chat and the quote opens from there to be approved and turned into an order, with no hunting for it.',
  whatsapp_addon_status_title: 'Production updates',
  whatsapp_addon_status_text:
    'Every suborder status change reaches the customer on the channel they chose.',
  whatsapp_addon_hours_title: 'Business hours and templates',
  whatsapp_addon_hours_text:
    'Your own business hours and approved templates to reply after hours.',
  walks_in: 'Walks-in',
  facebook: 'Facebook',
  instagram: 'Instagram',
  tik_tok: 'Tik Tok',
  soldby: 'Selling formula',
  special_customer: 'Special price for customers',
  specific: 'Specific information',
  sporadic: 'Sporadic',
  start_date: 'Start date | Starting date',
  start_user_chat: 'Start chat with user',
  start_whatsapp_chat: 'Message on WhatsApp',
  start_whatsapp_hint:
    'This customer has not written yet, so WhatsApp only allows opening the conversation with an approved template.',
  state: 'State',
  status: 'Status',
  stock: 'On Hand',
  subcategory: 'Sub-Category',
  subdomain: 'Subdomain | Subdomains',
  subitem: 'Sub-Item | Sub-Items',
  subitems_not: 'Create without subitems',
  subitems: 'Subitems {value}',
  subject: 'Subject',
  subname: 'Sub-project name',
  suborder_action: {
    created: 'created',
    updated: 'updated',
    deleted: 'deleted',
    access: 'access'
  },
  suborder_code: 'Sub-order code',
  suborder_description: 'Sub-order description',
  suborder_name: 'Sub-order name',
  suborder: 'Sub-order | Sub-orders',
  suborderstatus: 'Sub-order Status',
  subordersubstatus: 'Sub-order Substatus',
  subtotal: 'Subtotal',
  success: '{model} {action} successfully',
  suffix: 'Suffix',
  summary: 'Summary',
  supplier_manager: 'Supplier management',
  supplier_personal_info: `Provider's Personal Information`,
  supplier_type: 'Supplier Type',
  supplier_type: 'Supplier Type',
  supplier: 'Supplier|Suppliers',
  supplierAddress: 'Supplier Address',
  supplierCompany: 'Supplier Name or Company',
  supplierlevel: 'Supplier type | Supplier types',
  suppliersReport: 'Suppliers report',
  sustrate: 'Substrate',
  tab_name: 'Tabs name',
  tab: 'Tab',
  tabs: 'Tabs',
  tabs_must_be_unique: 'Tabs title must be unique',
  tax_id: 'Tax Pay Number|Tax Pay Number (Optional)',
  tax: 'Tax',
  taxes_info: 'Taxes info',
  telegram: 'Telegram',
  production_details_template: 'Production details template',
  template: 'Template',
  templates_email: 'Email Template | Email Templates',
  terms: 'Payment term | Payment terms',
  test_formula: 'Test this formula',
  text: 'Text',
  textile_colors: 'Textile Colors',
  there_are_no_images_yet: 'There are no images yet',
  time: 'Time',
  tip: 'Tip|Tips',
  title_color: 'Title color',
  title_discount: 'Discount',
  title_extra: 'Extra',
  title: 'Title',
  to: 'To',
  total: 'Total',
  turnaround: 'Turnaround days',
  type_acquisition: 'Type of equipment acquisition',
  type_recurrent: 'Type of Recurrent',
  type: 'Type',
  typecontact: 'Contact type|Contact types',
  typedate: 'Date Type',
  typedatealert:
    "If you don't select a template, this type of date will be general",
  unavailable: 'Unavailable',
  unitprice: 'Unit price',
  unknown: 'Unknown',
  update: 'Update | Updated | updated | Updated',
  updated_date: 'Update date',
  updated_user: 'Updated user',
  updated: 'Updated',
  upload_image: 'Upload image',
  upload_logo: 'Upload logo',
  user_panel: 'User Panel',
  user: 'User | Users | user | users',
  username: 'Username | Username / Email',
  users_select: 'Select users',
  users_set_groups: 'Users assigned to groups',
  users_set_permissions: 'Users are assigned permissions',
  value_must_be_greater: '{value} must be greater',
  value: 'Value | Values',
  voided: 'Voided',
  wantToAssignDesigner: 'You want to assign a designer?',
  web_url: 'Web URL',
  wednesday: 'Wednesday',
  week: 'Week',
  weekly: 'Weekly',
  welcome_company: 'Welcome to {value}',
  welcome: 'Welcome',
  weight_limit_exceeded:
    'The file you supply exceeds the weight limit, please enter a lighter one.',
  what_groups: 'What are the groups to add?',
  what_permissions: 'What are the permissions to add?',
  what_users: 'What are the users to add?',
  whatsapp: 'WhatsApp',
  no_orders_yet: 'This customer has no orders yet',
  no_results_for: 'No results for "{search}"',
  whatsapp_active_for_company: 'WhatsApp active for this company',
  whatsapp_chat_started: 'Message sent',
  whatsapp_connected: 'Connected with number {phone}',
  whatsapp_connected_ok: 'WhatsApp connected',
  whatsapp_error_131026:
    'The number has no WhatsApp or cannot receive messages.',
  whatsapp_error_131030:
    'The customer number is not in the authorised test list.',
  whatsapp_error_131047:
    'More than 24 hours passed: reply with an approved template.',
  whatsapp_error_133010:
    'The print shop number is not registered with WhatsApp.',
  whatsapp_error_auth:
    'The channel credentials expired. WhatsApp must be connected again.',
  whatsapp_field_code: 'Order code',
  whatsapp_field_name: 'Job name',
  whatsapp_field_status: 'Status',
  whatsapp_not_configured:
    'This company has no WhatsApp account configured yet',
  whatsapp_state_attending: 'Attending',
  whatsapp_state_closed: 'Closed',
  whatsapp_state_follow_up: 'Follow up',
  whatsapp_state_new: 'New',
  whatsapp_state_quote_sent: 'Quotation sent',
  whatsapp_state_waiting_customer: 'Waiting for customer',
  whatsapp_status_active: 'Active',
  whatsapp_status_failed: 'Failed',
  whatsapp_status_pending: 'Pending',
  whatsapp_status_provisioning: 'Provisioning',
  whatsapp_status_suspended: 'Suspended',
  whatsapp_template_delivery: 'Order on its way',
  whatsapp_template_in_process: 'Order in production',
  whatsapp_template_quote_sent: 'Quotation sent',
  whatsapp_template_ready_to_deliver: 'Order ready',
  width: 'Width',
  window_authentication: 'Authentication',
  window_closed:
    '24 hours have passed since the customer last wrote. Only an approved template can be sent.',
  window_marketing: 'Marketing',
  window_service: 'Service',
  window_utility: 'Utility',
  with_autoprice:
    'The prices by percentage when saving will be adjusted the corresponding \
    amounts according to the cost',
  with_subitems: 'With sub-items',
  without: 'without',
  without_price: 'Without price',
  without_subitems: 'Without sub-items',
  write_a_message: 'Write a message',
  write_message: 'Write a message',
  wrong_file_type: 'Wrong file type',
  yearly: 'Yearly',
  yes: 'Yes',
  zip_code: 'Zip Code',
  zoom_in: 'Zoom in',
  read: 'Read',
  unread: 'Unread',
  apparel_colors: 'Apparel colors',
  hex_code: 'Hex Code',
  clone_colors: 'Clone colors',
  select_at_least_one_color: 'You must select at least one color',
  no_colors_provided: 'No colors provided',
  company_not_found: 'Company not found',
  cannot_delete_color_associated:
    'The color cannot be deleted because it is associated with one or more products.',
  saved: 'Saved successfully',
  color_name_already_exists:
    'The color "{name}" already exists by name in your list.',
  color_name_exists: 'A color with this name already exists.',
  black: 'Black',
  white: 'White',
  navy_blue: 'Navy Blue',
  red: 'Red',
  orange: 'Orange',
  gray: 'Gray',
  apparel_readonly_message:
    'Textile configuration can only be set when creating the product.',
  cannot_delete_apparel_in_use:
    'Cannot delete apparel item because it is in use.',
  apparel_name_already_exists: 'An apparel item with this name already exists.',
  error_saving_apparel: 'Error saving apparel item.',
  cannot_delete_style_in_use: 'Cannot delete style because it is in use.',
  style_name_already_exists:
    'A style with this name already exists for this apparel.',
  error_saving_style: 'Error saving style.',
  cannot_delete_fabric_in_use:
    'Cannot delete fabric type because it is in use.',
  fabric_name_already_exists: 'A fabric type with this name already exists.',
  error_saving_fabric: 'Error saving fabric type.',
  cannot_delete_brand_in_use: 'Cannot delete brand because it is in use.',
  brand_name_already_exists: 'A brand with this name already exists.',
  error_saving_brand: 'Error saving brand.',
  cannot_delete_gender_in_use: 'Cannot delete gender because it is in use.',
  gender_name_already_exists: 'A gender with this name already exists.',
  error_saving_gender: 'Error saving gender.'
}
